module.exports = __webpack_public_path__ + "static/media/five.f8a061c3.svg";